import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PaymentRedirect from './views/Payments/PaymentRedirect.vue'
import PaymentDetails from './views/Payments/PaymentDetails.vue'
import SuccessCallback from './views/Payments/CallbackSuccess.vue'
import CancelledCallback from './views/Payments/CallbackCancelled.vue'

import CRBuildingSurveyTerms from './views/Payments/Terms/CRBuildingSurvey.vue'
import CRHomemoverTerms from './views/Payments/Terms/CRHomemover.vue'
import SDBuildingSurveyTerms from './views/Payments/Terms/SDBuildingSurvey.vue'
import SDHomemoverTerms from './views/Payments/Terms/SDHomemover.vue'

import VendorChecklistRedirect from './views/VendorChecklist/ChecklistRedirect.vue'
import VendorChecklist from './views/VendorChecklist/Checklist.vue'
import VendorChecklistSuccess from './views/VendorChecklist/Success.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    /* Vendor Checklist */
    {
      path: '/vendor/redirect/:jobToken',
      name: 'vendor-redirect',
      component: VendorChecklistRedirect,
      props: true
    },
    {
      path: '/vendor/checklist',
      name: 'vendor-checklist',
      component: VendorChecklist,
      props: true
    },
    {
      path: '/vendor/checklist/thankyou',
      name: 'vendor-checklist-success',
      component: VendorChecklistSuccess
    },
    /* Job Payment */
    {
      path: '/payment/redirect/:jobToken',
      name: 'payment-redirect',
      component: PaymentRedirect,
      props: true
    },
    {
      path: '/payment/details',
      name: 'payment-details',
      component: PaymentDetails,
      props: true
    },
    {
      path: '/payment/success',
      name: 'payment-success',
      component: SuccessCallback
    },
    {
      path: '/payment/cancelled',
      name: 'payment-cancelled',
      component: CancelledCallback
    },
    {
      path: '/payment/terms/cr/hmv',
      name: 'payment-terms-cr-hmv',
      component: CRHomemoverTerms
    },
    {
      path: '/payment/terms/cr/bs',
      name: 'payment-terms-cr-bs',
      component: CRBuildingSurveyTerms
    },
    {
      path: '/payment/terms/sid/hmv',
      name: 'payment-terms-sd-hmv',
      component: SDHomemoverTerms
    },
    {
      path: '/payment/terms/sid/bs',
      name: 'payment-terms-sd-bs',
      component: SDBuildingSurveyTerms
    }
  ]
})
